module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "السَّمَاءُ-صلبَة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("السَّمَاءُ صلبَة")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يقولُ اللهُ تعالى في سورَة النَّبَأ:")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("﴿")])]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("وَبَنَيْنَا فَوْقَكُمْ سَبْعًا شِدَادًا")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية [12]")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقالَ في سورة الحاقَّة:")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("﴿وَانْشَقَّتِ السَّمَاءُ")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية [16]")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقالَ في سورة الأنبياء:")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("﴿وَجَعَلْنَا السَّمَاءَ سَقْفًا مَحْفُوظًا")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية [32]")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وجاءَ في نَفْسِ السورة")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("﴿يَوْمَ نَطْوِي السَّمَاءَ كَطَيِّ السِّجِلِّ لِلْكُتُبِ")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية [104]")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فالسماءُ بأمرِ اللهِ بُنِيَتْ وهي سقفٌ ولها أَبوابٌ، وبأمرِهِ سبحانه وتعالى تتَصَدَّعُ وتَنشَقُّ يومَ القيامَةِ وتُطْوَى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وَالوَصْفُ البَسيطُ للسَّماءِ على أنَّها تتكَوَّنُ من أعدادٍ لا نهائية من المجراتِ ونجومِها وتوابِعها مِن الكواكب، وكذلكَ الحديثُ عن مسافاتٍ هائلة في الفَضاء تسبحُ فيها الأجرامُ السماوية، لا ينطبقُ عليه ما جَاءَ في الآياتِ الكَريمَة أعْلاه، وإنَّما يَنْطَبِقُ على جِسْمٍ صلْبٍ شديدٍ هي مادَّةُ السَّماءِ، فالسَّائِلُ والغازُ لا يُبْنى ولا يُطْوَى ولا يَتَشَقَّقُ أو يَتَصَدَّعُ، ولِكَي لا ينهارَ سَقفٌ عادِيٌّ أو يَسقُطَ يجبُ أَن يكونَ صلباً شديداً متماسِكاً كي يستطيعَ مقاومَةَ ما قد يتعرضُ له من قُوًى وأحمالٍ تُضافُ كذلك إلى وزنِهِ الأساسي، فكيفَ إذا كان الحديثُ عن سقفٍ بحجم وعظمةِ السماء؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وبالمُقارنَةِ بين مُكَوِّناتِ السَّماءِ ومكوِّناتِ المادَّة فإنَّ فَراغاً هائِلاً تَدورُ فيهِ الإلكترونات يُحيطُ بنواةِ كلِّ ذرَّة من الذرَّات المُكَوِّنَة لجزَيئاتِ المادَّة الواحدة تماماً كَما تدورُ تَوابِعُ النُجومِ حَوْلَها في مَداراتٍ بَعيدة مُحَدَّدَة، وعَلَيْهِ فإِنَّ أوجُهَ الشَبَهِ كذلك كَبيرَةٌ بينَ الذَّرَّة ومجموعتِنا الشمسيَّة، وَلَمَّا كانت نِسبَةُ الفَراغِ في بعضِ الموادِّ تَصِلُ إلى أكثرَ من 99٪ فإنَّ حجْمَ النُجومِ وتوابِعَها نِسْبَةً للفضاءِ المحيطِ بها يُحَقِّقُ ويُوَفِّرُ هذه النِّسْبَة البَسيطةِ من المادَّة المطلوبِ تَوافُرَها في الأجسامِ عامَّةً كَي تَكونَ صلْبَة نِسبَةً للفراغ المحيط بِنُواةِ ذَرَّاتِ كلٍّ منها، فالسَّماءُ على هذا النَّحو كذلِكَ صلبَةٌ، وبذلِكَ فإنَّنا نَبدو وَكَأَنَّنَا – واللهُ")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وحدَهُ سبحانَه وتعالى أعلى وأعلَمُ – أمامَ نُموذَجٍ كبيرٍ هائِلٍ للمواد يختلفُ عن المواد التي نعرِفُها، أَلا وَهْوَ مادَّةُ السَّماء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فالنَّاظِرُ من داخلِ الذَّرَّة المُكوِّنَة للموادَّ ومِن على سطحِ نُواتِها التي تمثِّلُ المادَّة فيها لِمَا حَولَه مِن فَراغ هائِل أيضاً يَرى نواةَ كلٍّ مِن الذراتِ الأخرى المُحيطَة به على بعدٍ مَهولٍ منهُ نِسْبِياً")]), _vm._v(" }"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قد يَصِل إلى ثلاثة كيلو مترات إذا ما افْتَرَضْنا أنَّ حَجْمَ النواةِ الواحدَةِ يُساوي حجمَ كُرَةِ القَدَم")]), _vm._v("{"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، وذلكَ ضِمْنَ عالمِ الذرات المُتَناهي في الصِّغَرِ والذي نَتَحدَّثُ عنهُ هُنا في هذا المَجال، فتَبدو له المادَّة وكأنها فارِغَةٌ من داخلِها، ويَكونُ حالُه عندَ النّظَرِ من ذلكَ المكان الافتِراضي داخلَ المادة")]), _vm._v(" }"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مِن على سطحِ نُواة الذرة")]), _vm._v("{ "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لِمَا حَولَهُ تماماً كَحالِنا نحنُ البشَر على هذا الكوكبِ، ونحن جزءٌ من هذه السماء ونَنْظُرُ من داخِلِها إلى الفَضاءِ المحيطِ بنا ونَرى ما يُشبِهُ ما يَرَاه بالقياسِ النِّسبي، فتَبدو لنا السماءُ وكَأَنَّها أيضاً فارِغَة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فكما أنَّ مَجموعَ الذرَّاتِ المُكَوّنَة للجزيئات تُشَكِّلُ الموادَّ التي تَبْدو لنا في النِهاية صلْبَةً ومُتَجانِسَة، فَكُلُّ سَماءٍ سَتَبدو كَذلِكَ من خارِجِهَا وعَنْ بُعْدٍ متَجانِسَة وكُتلَةً صَلْبَةً واحِدَة لا يكونُ فيها منفذٌ إلَّا من خِلالِ أبوابٍ وضَعَها اللهُ سبحانَه وتعالى لها، في حين أنَّ المَجَرات تظهَرُ لنا عن بُعْد على شكلِ ملياراتِ الأقراصِ المُغلَقَة والمجموعاتُ البعيدةُ جداً مِنها تظهرُ على أَشكالٍ عنقوديَّة أو عنكبوتيَّة متلاصِقَة ومتَّحِدة، ومنها ما يلتهِمُ بعضُها بعضاً تَبَعاً للتَّبايُنِ في أَحجامِها رُغم المسافاتِ الهائِلَة بينَها، الأمر الذي يشيرُ إلى أنَّ مَشهَدَ كلِّ سَمَاءٍ مِن خارجِ الكَون يُشكِّلُ – واللهُ أعْلى وأعْلَم – سَقْفاً واحداً.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فهل مَجَرَّتُنَا هي إحَدى جزيئات مادَّةِ السَّماء؟ وهل نحن نَعيشُ وتَسبَحُ سُفُنٌ في الفَضاءِ وتَجري أُخرى في مُحيطاتٍ وتَتَصارَعُ دولٌ عُظمى على مناطِقِ النُّفوذِ والسيادَة فيما بينها داخِلَ جُزَيْءٍ أو ذرَّةٍ مِن المادَّة؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فَكَمَا أَنَّ المَوادَّ التي نَعرِفُها تَتَشَكَّلُ من جزيئاتٍ ترتَبِطُ مَعاً برَوابِطَ وقوًى مُختلفَة وتَبْدو أمَامَنا على شَكْلِ قِوامٍ صلْبٍ مُتَجانِسٍ، كذلِكَ فَإِنَّ السَّماءَ أيْضاً قِوامُها مُتَجانِسٌ وصلبٌ، وتَتَشَكَلُ مِمَّا يُقارِبُ تريليونَ مَجَرَّة، كلٌّ منها مُكَوَّنَة من مليارات النُجوم، ولِكلٍّ مِنَ النجومِ توابِع، أحَدُها الأرضُ التي نَعيشُ عليها والتي تدورُ حولَ الشمسِ، ومُحَمَّلَةٌ أيضاً بالشحناتِ الكهربائيَّة المُماثِلة لشُحنات الإلكترونات التي تدورُ حولَ نُواةِ الذرَّاتِ داخل المادَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في حين تَنتَشِرُ بين المَجَرَّاتِ المادَّةُ السَّوْداءُ التي تَضْمَنُ تَماسُكَ الأجْرامِ السّماوية، وتقومُ بعملٍ مشابِهٍ لعمل السيتوبلازما في الخَلايا الحَيَّة في حِفْظِ مُكوِّناتِ الخلايا كُلٌّ في مكانِه، تماماً كما يَعْمَل الـ (جِيلي) ذو القَوامِ الضَّعيفِ في الحِفاظ على قَوام وتماسُك قِطَع الفَواكِه في قَالَبِ الحَلوَى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ونحنُ هنا إذْ يَقْتَصِرُ حَديثُنا عن الأَرقام الخاصَّة بالكَوْن المَرْئي حالياً بفَضلِ المعلومات التي توَفِّرُها التلسكوباتِ العملاقة التي تَمَّ بِناؤها حَديثاً، لا بُدَّ أَنْ نُشيرَ إلى أَنَّ الحَجْمَ الحقيقي للكَون يتجاوزُ بمئات المليارات أَضْعافَ حَجمِ الكَون المَرْصودِ والمَرْئي عِلمياً حَسَبَ ما يَتَوَقَّعُ العُلماء، وبالتأكيد فإنَّ الكَونَ المعروف لنا حالياً سيتَّسِع حجْمُه ويزدادُ عددُ مجرَّاتِه مع تطَوُّرِ أنظمةِ رصدِ الفَضاء مستقبَلاً عندَ دخولِ التلسكوباتِ العملاقة")]), _vm._v(" }"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التي يجري بناؤها حالياً في أنحاءَ شَتَّى مِن العالم")]), _vm._v("{ "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("للخدمَة، ونشير في سياق الحديث في هذا المجال إلى صُعوبَة رؤيةِ الأجرامِ السَّماويَّة الضَّخمة مِن نقطةٍ واحدة على الأرض، وَقد يلزمُ لتصويرِ جُرمٍ سمَاويٍ هائِل واحِد استخدامُ عدد من التلسكوباتِ المنتَشِرة في أماكنَ مختلفةٍ حولَ العالم، وذلكِ بتشغيلِها للعملِ معاً في نفسِ الوقت لإنجازِ ذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولَمَّا كَانَ قَدَرُ الإنسانِ الذي أَرادَهُ وأَذِنَ بِهِ سبحانَهُ لنا هو العيشَ بينَ حَجْمِ الذرَّاتِ المُكَوِّنَة للمادَّة المُتناهي في الصِّغَر وبينَ حَجْمِ هذا الكَوْنِ الهائِل، فإنَّ ذلكَ يُتيحُ لنا مُشاهدَة المادَّة مِن خارِجَها، أمَّا النَّظَرُ للسّماءِ ومُشَاهدَةُ الكَوْنِ فَهوَ مُتاحٌ لنا فقط مِن داخِلِهِ، فسبحانَ اللهِ العظيمِ الخالقِ المبدع، نشهَدُ لكَ اللهمَّ بالوحدانية، ولا نُحصِي ثناءً عليكَ، أنتَ كما أَثنَيْتَ على نَفسِك."), _c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 84
// module chunks = 0